import React from 'react';
import DatasetAttachmentRow from './DatasetAttachmentRow';
import { getAttachmentType } from '../helper';
import { ATTACHMENT_TYPE } from '../constants';
import FolderRow from './FolderRow';

const RowComponentMap = {
  [ATTACHMENT_TYPE.folder.name]: FolderRow,
  [ATTACHMENT_TYPE.attachment.name]: DatasetAttachmentRow,
  [ATTACHMENT_TYPE.datafile.name]: DatasetAttachmentRow,
};

const DatasetAttachmentRows = ({
  category,
  code,
  columns,
  items,
}) => (
  items.map((attachment, index) => {
    const attachmentType = getAttachmentType(attachment);
    const RowComponent = RowComponentMap[attachmentType.name];

    return (
      <RowComponent
        attachment={attachment}
        category={category}
        code={code}
        columns={columns}
        key={`dataset_attachment_row_${attachment.id}`}
        upward={index >= 2}
      />
    );
  })
);

export default DatasetAttachmentRows;
